import { render, staticRenderFns } from "./ydsView.vue?vue&type=template&id=3237db71&scoped=true"
import script from "./ydsView.vue?vue&type=script&lang=js"
export * from "./ydsView.vue?vue&type=script&lang=js"
import style0 from "./ydsView.vue?vue&type=style&index=0&id=3237db71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3237db71",
  null
  
)

export default component.exports